import React, { useState, useEffect, Fragment } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  IconButton,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { makeStyles } from "@mui/styles";
import { Clear } from "@mui/icons-material";
import { SystemConstant } from "const";
import { useBranchRequestUpdate, useDepartmentDetails, useUnitDetails, useUnitList } from "hooks";
import { format } from 'date-fns';
import Autocomplete from '@mui/material/Autocomplete';

const FormUpdateBranchRequest = ({ user, isOpenFormAccept, onCloseForm, refetch, onOpenConfirm }) => {
  const classes = useStyles();
  const { t: getLabel } = useTranslation();
  const { updateBranchRequest } = useBranchRequestUpdate();

  const { totalUnitList } = useUnitList();
  const { positions: positionsByUnit, departments, handleGetUnitDetails } = useUnitDetails();
  const { positions: positionsByDepartment, handleGetDepartmentDetails } = useDepartmentDetails();
  const [positions, setPositions] = useState([]);

  const [updateBirthday, setUpdateBirthday] = useState(null);
  const [updateUnit, setUpdateUnit] = useState("");
  const [updateDepartment, setUpdateDepartment] = useState("");
  const [updatePosition, setUpdatePosition] = useState("");
  const [departmentValue, setDepartmentValue] = useState(null);
  const [positionValue, setPositionValue] = useState(null);

  console.log(departments, positions, totalUnitList)
  const handleChangeUnit = (event, newInputValue) => {
    console.log(newInputValue)
    setUpdateUnit(newInputValue.unitId);
    handleGetUnitDetails(newInputValue.unitId);
    setDepartmentValue(null)
    setUpdateDepartment(null);
    setPositionValue(null)
    setUpdatePosition(null);
  };

  const handleChangeDepartment = (event, newInputValue) => {
    setDepartmentValue(newInputValue || null)
    setUpdateDepartment(newInputValue?.departmentId);
    handleGetDepartmentDetails(newInputValue?.departmentId);
    setPositionValue(null)
    setUpdatePosition(null);
  };

  const handleChangePosition = (event, newInputValue) => {
    setUpdatePosition(newInputValue || null)
    setUpdatePosition(newInputValue?.positionId);
  };

  useEffect(() => {
    setDepartmentValue(null);
  },[departments])

  useEffect(() => {
    setPositionValue(null);
  },[positions])


  const handleAccept = () => {
    updateBranchRequest({
      branch_request_ids: [user.id],
      status: SystemConstant.BRANCH_REQUEST_STATUS.ACCEPTED.status,
      birthday: updateBirthday ? format(updateBirthday, "dd-MM-yyyy") : null,
      unit_id: updateUnit,
      department_id: updateDepartment,
      position_id: updatePosition,
      refetch: refetch,
      onClose: () => onCloseForm,
    });
  };

  useEffect(() => {
    if (positionsByUnit) setPositions(positionsByUnit);
  }, [positionsByUnit]);

  useEffect(() => {
    if (positionsByDepartment) setPositions(positionsByDepartment);
  }, [positionsByDepartment]);

  return (
    <Fragment>
      <Dialog open={isOpenFormAccept} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "8px 0" }}>
          <Typography sx={{ fontWeight: 700, fontSize: "24px" }}>Thêm thành viên mới</Typography>
          <IconButton onClick={onCloseForm}>
            <Clear />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ height: "550px", overflowY: "scroll" }}>
          <Typography sx={{ fontWeight: "bold" }}>Ghi chú từ người yêu cầu:</Typography>
          <Typography sx={{ marginBottom: "8px" }}>{user.note}</Typography>

          <TextField
            label="Họ và tên (*)"
            fullWidth
            defaultValue={user?.name || ""}
            className={classes.infoField}
            disabled
            name="full-name"
          />
          <TextField
            label="Số điện thoại (*)"
            fullWidth
            defaultValue={user?.phone || ""}
            className={classes.infoField}
            disabled
            name="phone"
          />
          <TextField
            label="Email (*)"
            fullWidth
            type="email"
            defaultValue={user?.email || ""}
            className={classes.infoField}
            disabled
            name="email"
          />
          <Box className={classes.datePicker}>
            <LocalizationProvider dateAdapter={AdapterDateFns} sx={{ with: "100%" }}>
              <DatePicker
                label="Ngày sinh"
                value={updateBirthday}
                format="dd/MM/yyyy"
                className={classes.infoField}
                onChange={e => {
                  setUpdateBirthday(e);
                }}
              />
            </LocalizationProvider>
          </Box>
          <FormControl className={classes.infoField} fullWidth>
            <Autocomplete
              labelId="unit-select-label"
              id="unit-select"
              label={getLabel("TXT_UNIT")}
              options={totalUnitList}
              getOptionLabel={(option) => {
                return option.unitName;
              }}
              onChange={handleChangeUnit}
              renderInput={(params) => {
                return (<TextField
                  {...params}
                  label="Đơn vị"
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      type: 'search',
                    },
                  }}
                />)
              }}

            />

          </FormControl>
          <FormControl className={classes.infoField} fullWidth>

            <Autocomplete
              labelId="department-select-label"
              id="department-select"
              label={getLabel("TXT_DEPARTMENT")}
              options={departments}
              getOptionLabel={(option) => {
                return option.departmentName;
              }}
              value={departmentValue}
              onChange={handleChangeDepartment}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Phòng ban"
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      type: 'search',
                    },
                  }}
                />
              )}
            />
          </FormControl>
          <FormControl className={classes.infoField} fullWidth>
            <Autocomplete
              labelId="position-select-label"
              id="position-select"
              options={positions}
              getOptionLabel={(option) => {
                return option.positionName;
              }}
              disableClearable
              onChange={handleChangePosition}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Vị trí"
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      type: 'search',
                    },
                  }}
                />
              )}
            >
            </Autocomplete >
          </FormControl>
        </DialogContent>

        <Box
          sx={{ width: "100%", marginBottom: "8px", display: "flex", flexDirection: "column", alignItems: "center" }}
        >
          <Button variant="contained" color="primary" sx={{ width: "90%", margin: "8px" }} onClick={handleAccept}>
            Thêm
          </Button>
          <Button variant="contained" color="error" sx={{ width: "90%", margin: "8px" }} onClick={onOpenConfirm}>
            Từ chối
          </Button>
        </Box>
      </Dialog>
    </Fragment>
  );
};

export default FormUpdateBranchRequest;

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  status: {
    cursor: "pointer",
    width: "130px",
    position: "static",
  },

  iconButton: {
    border: "1px solid #D4D5D8",
    width: "32px",
    height: "32px",
  },

  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px",
    fontWeight: "bold",
  },

  infoField: {
    margin: "10px 0px",
  },

  datePicker: {
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
}));
